// skeleton/app/src/app/rs-landing/rs-landing.component.ts

import { Component, OnInit } from "@angular/core";
import { UserServiceService } from "../user/survey-main/service/user-service.service";
import { GlobalsessionhandlerService } from "../shared/services/globalsessionhandler.service";
import { BaseHttpService } from "../shared/services/basehttp.service";
import { Constants } from "../shared/constants";
import { MenubarService } from "../shared/services/menunavbar.services";
import { firstValueFrom } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import DOMPurify from "dompurify";

import { TokenStorageService } from "../shared/services/token-storage.service";

@Component({
  selector: "app-rs-landing",
  templateUrl: "./rs-landing.component.html",
  styleUrl: "./rs-landing.component.scss",
  standalone: false,
})
export class RsLandingComponent {
  userName: string = "";
  constants: Constants = new Constants();
  surveyDueDate: Date;
  diffDate: number;
  bannerString: string = "";
  agencyName: string = "";
  formattedDate: string;
  bannerDetails: any;

  constructor(
    private userService: UserServiceService,
    private sessionHandlerService: GlobalsessionhandlerService,
    private baseHttpService: BaseHttpService,
    private sanitizer: DomSanitizer,


    private storage: TokenStorageService
  ) {}

  async ngOnInit() {
    this.userName = this.storage.get("LoggedInuserFirstName");
    this.agencyName =
      this.storage.get("LoggedInUserAgency") != null
        ? this.capitalizeWords(this.storage.get("LoggedInUserAgency").toLowerCase())
        : "";

    if (this.userName == null || this.agencyName == null) {
      this.GetUser();
    }

    // Hardcoded date: March 16, 2026
    this.surveyDueDate = new Date("2026-03-16");
    this.formattedDate = "March 16, 2026";

    this.GetSurveyBannerDetails();
  }

  GetUser() {
    this.baseHttpService.get(this.constants.getUser).subscribe((result) => {
      if (result != null) {
        this.userService.getUserDeatils(result);
        let loginname = result.fullName.split(",");
        this.userName = loginname[1];
        this.agencyName = result.userAgency;

        this.storage.set("LoggedInuserId", JSON.stringify(result.customerId));
        this.storage.set("LoggedInuserMailId", result.email);
        this.storage.set("LoggedInUserTypeId", result.userTypeId);
        this.storage.set("LoggedInUserTypeDesc", result.userTypeDesc);
        this.storage.set("LoggedInUserAgency", result.userAgency);

        this.sessionHandlerService.setLoggedInUserName(
          loginname[1].trim() + ", " + loginname[0].trim()
        );

        this.sessionHandlerService.setUserGroupId(result.userGroupId);
        this.storage.set("UserGroupId", result.userGroupId);
      }
    });
  }

  GetSurveyBannerDetails() {
    const userType = this.storage.get("LoggedInUserTypeDesc");
    const userGroupId = this.storage.get("UserGroupId");
    const url = this.constants.getSurveyBannerDetails + "/" + userType + "/" + userGroupId;

    if (userType != null && userGroupId != null) {
      this.baseHttpService.get(url).subscribe((data) => {
        data.sort((a, b) => a.sequence - b.sequence);
        data.forEach((x) => {
          const cleanHtml = DOMPurify.sanitize(x.htmlText);
          x.htmlText = this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
        });
        this.bannerDetails = data;
      });
    }
    return null;
  }

  capitalizeWords(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }
}
